export const categories = [
  {
    slug: 'quanji',
    name: '全集',
    icon: 'ri-play-list-2-line',
    description: '爱情岛视频全集高清在线播放，收录完整系列内容',
    count: 128,
  },
  {
    slug: 'zuixin',
    name: '最新更新',
    icon: 'ri-fire-line',
    description: '最新爱情岛视频资源实时更新，第一时间观看精彩内容',
    count: 36,
  },
  {
    slug: 'jingxuan',
    name: '精选推荐',
    icon: 'ri-star-line',
    description: '编辑精选爱情岛视频，高口碑高人气作品推荐',
    count: 24,
  },
  {
    slug: 'gaoqing',
    name: '高清专区',
    icon: 'ri-4k-line',
    description: '4K超清画质爱情岛视频，极致的视觉体验',
    count: 56,
  },
  {
    slug: 'jingdian',
    name: '经典回顾',
    icon: 'ri-history-line',
    description: '经典爱情岛视频回顾，重温那些难忘的精彩瞬间',
    count: 42,
  },
  {
    slug: 'huaxu',
    name: '精彩花絮',
    icon: 'ri-movie-line',
    description: '爱情岛视频幕后花絮，独家片场精彩片段',
    count: 18,
  },
  {
    slug: 'jijin',
    name: '集锦合集',
    icon: 'ri-stack-line',
    description: '爱情岛视频精华集锦，高能片段一次性看过瘾',
    count: 30,
  },
  {
    slug: 'fangtan',
    name: '访谈专题',
    icon: 'ri-mic-line',
    description: '爱情岛嘉宾访谈，深入了解故事背后的人物',
    count: 15,
  },
];

export const videos = [
  {
    id: 'v001',
    slug: 'aiqingdao-zhi-langman-haiwan',
    title: '爱情岛之浪漫海湾',
    category: 'quanji',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20romantic%20tropical%20beach%20sunset%20scene%20with%20gentle%20waves%20and%20palm%20trees%2C%20warm%20golden%20hour%20lighting%2C%20soft%20dreamy%20atmosphere%2C%20cinematic%20wide%20shot%2C%20beautiful%20couple%20silhouette%20walking%20on%20shore%2C%20luxury%20resort%20style%2C%20high%20quality%20photography&width=640&height=360&seq=video-thumb-001&orientation=landscape',
    duration: '45:32',
    views: 128000,
    date: '2026-08-05',
    description: '在浪漫的海湾边，爱情的故事悄然展开。本集记录了三对情侣在美丽海湾共度的温馨时光，沙滩、日落与真诚告白交织成最动人的画面。',
    tags: ['浪漫', '海滩', '告白'],
    rating: 9.2,
  },
  {
    id: 'v002',
    slug: 'aiqingdao-zhi-chengshi-yu',
    title: '爱情岛之城市遇见',
    category: 'quanji',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20romantic%20urban%20cityscape%20at%20twilight%20with%20warm%20street%20lights%2C%20cobblestone%20streets%2C%20cozy%20cafe%20terrace%2C%20soft%20bokeh%20effect%2C%20cinematic%20photography%2C%20elegant%20couple%20enjoying%20coffee%2C%20golden%20and%20rose%20tones&width=640&height=360&seq=video-thumb-002&orientation=landscape',
    duration: '52:18',
    views: 96500,
    date: '2026-08-03',
    description: '都市丛林中，两颗心的奇妙碰撞。本期爱情岛视频来到繁华都市，见证在快节奏生活中如何守护真挚感情。咖啡馆的邂逅、天台的对话，每一帧都满载浪漫。',
    tags: ['都市', '邂逅', '浪漫'],
    rating: 9.5,
  },
  {
    id: 'v003',
    slug: 'aiqingdao-zhi-shanjian-qiyu',
    title: '爱情岛之山间奇遇',
    category: 'quanji',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20mountain%20landscape%20with%20misty%20valleys%2C%20wildflowers%20in%20foreground%2C%20couple%20hiking%20on%20scenic%20trail%2C%20warm%20sunlight%20filtering%20through%20trees%2C%20cinematic%20nature%20photography%2C%20romantic%20adventure%20vibe%2C%20soft%20warm%20tones&width=640&height=360&seq=video-thumb-003&orientation=landscape',
    duration: '48:56',
    views: 87500,
    date: '2026-08-01',
    description: '远离尘嚣，在山野间寻找最纯粹的爱情。本集爱情岛视频带观众走进秀美山川，在山间小屋、林中漫步的浪漫场景中，感受慢节奏的美好。',
    tags: ['山野', '自然', '慢生活'],
    rating: 9.0,
  },
  {
    id: 'v004',
    slug: 'aiqingdao-zhi-xingkong-xia-de-shiyan',
    title: '爱情岛之星空下的誓言',
    category: 'zuixin',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stunning%20starry%20night%20sky%20over%20a%20peaceful%20lakeside%2C%20silhouette%20of%20a%20couple%20sitting%20by%20campfire%2C%20milky%20way%20visible%2C%20warm%20firelight%20glow%2C%20romantic%20and%20dreamy%20atmosphere%2C%20cinematic%20night%20photography&width=640&height=360&seq=video-thumb-004&orientation=landscape',
    duration: '55:20',
    views: 156000,
    date: '2026-08-05',
    description: '星空为证，许下最真挚的诺言。本期最新爱情岛视频记录了在璀璨星空下发生的动人告白，星河与篝火交织成这个夏天最难忘的夜晚。',
    tags: ['星空', '告白', '感人'],
    rating: 9.8,
  },
  {
    id: 'v005',
    slug: 'aiqingdao-zhi-huayuan-wuhui',
    title: '爱情岛之花园舞会',
    category: 'zuixin',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20elegant%20garden%20party%20scene%20with%20blooming%20roses%2C%20fairy%20lights%20strung%20between%20trees%2C%20couples%20dancing%20in%20formal%20attire%2C%20soft%20golden%20evening%20light%2C%20romantic%20and%20whimsical%20atmosphere%2C%20cinematic%20photography&width=640&height=360&seq=video-thumb-005&orientation=landscape',
    duration: '41:15',
    views: 112000,
    date: '2026-08-04',
    description: '玫瑰花园中的浪漫舞会，裙摆飞扬间的心动瞬间。最新爱情岛视频为观众呈现了一场唯美至极的花园派对，优雅与浪漫并存。',
    tags: ['舞会', '花园', '优雅'],
    rating: 9.3,
  },
  {
    id: 'v006',
    slug: 'aiqingdao-zhi-haiyang-zhi-xin',
    title: '爱情岛之海洋之心',
    category: 'jingxuan',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20luxury%20yacht%20on%20crystal%20clear%20turquoise%20ocean%20water%2C%20couple%20enjoying%20sunset%20cruise%2C%20dolphins%20jumping%20in%20distance%2C%20warm%20golden%20light%2C%20cinematic%20aerial%20shot%2C%20romantic%20tropical%20paradise%20vibe&width=640&height=360&seq=video-thumb-006&orientation=landscape',
    duration: '50:42',
    views: 198000,
    date: '2026-07-28',
    description: '深入海洋之心，探寻爱情最纯净的模样。本集精选爱情岛视频，带领观众踏上奢华游艇之旅，在碧海蓝天中见证最动人的浪漫故事。',
    tags: ['海洋', '游艇', '精选'],
    rating: 9.7,
  },
  {
    id: 'v007',
    slug: 'aiqingdao-zhi-guangying-chuanqi',
    title: '爱情岛之光影传奇',
    category: 'jingxuan',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20vintage%20movie%20theater%20interior%20with%20warm%20ambient%20lighting%2C%20red%20velvet%20seats%2C%20romantic%20film%20projector%20glow%2C%20couple%20sharing%20popcorn%2C%20nostalgic%20and%20elegant%20atmosphere%2C%20cinematic%20photography&width=640&height=360&seq=video-thumb-007&orientation=landscape',
    duration: '62:10',
    views: 143000,
    date: '2026-07-25',
    description: '在光影交织的世界里，爱情故事历久弥新。本期精选爱情岛视频以电影为主题，记录了三对因电影结缘的情侣，在光影传奇中书写自己的爱情篇章。',
    tags: ['电影', '光影', '传奇'],
    rating: 9.4,
  },
  {
    id: 'v008',
    slug: 'aiqingdao-zhi-jingdian-zhongwen',
    title: '爱情岛之经典重温',
    category: 'jingdian',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20scene%20of%20old%20love%20letters%20and%20dried%20roses%20on%20a%20wooden%20desk%2C%20warm%20vintage%20tone%2C%20soft%20window%20light%2C%20sentimental%20atmosphere%2C%20classic%20romantic%20photography%20style%2C%20dust%20motes%20in%20sunlight&width=640&height=360&seq=video-thumb-008&orientation=landscape',
    duration: '58:30',
    views: 76500,
    date: '2026-07-20',
    description: '重温那些感动过千万人的经典爱情岛视频瞬间。从第一季到最新的动人片段，每一个画面都承载着观众的美好回忆。',
    tags: ['经典', '回顾', '感动'],
    rating: 9.6,
  },
  {
    id: 'v009',
    slug: 'aiqingdao-gaoqing-huayuan-pian',
    title: '爱情岛高清花园篇',
    category: 'gaoqing',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20magnificent%20botanical%20garden%20in%20full%20bloom%2C%20ultra%20HD%20quality%2C%20vibrant%20flower%20colors%2C%20butterflies%2C%20ornate%20fountain%2C%20couple%20walking%20hand%20in%20hand%2C%20crystal%20clear%20detail%2C%20cinematic%20photography%20with%20rich%20textures&width=640&height=360&seq=video-thumb-009&orientation=landscape',
    duration: '44:18',
    views: 92000,
    date: '2026-08-02',
    description: '4K超清画质下的爱情岛视频，每一帧都如画般精美。本期高清专区带来绝美花园场景，绚丽色彩与细腻画面带来极致视觉享受。',
    tags: ['4K', '高清', '花园'],
    rating: 9.1,
  },
  {
    id: 'v010',
    slug: 'aiqingdao-gaoqing-riben-pian',
    title: '爱情岛高清日落篇',
    category: 'gaoqing',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20sunset%20over%20the%20ocean%20with%20vivid%20orange%20and%20pink%20sky%2C%20silhouette%20of%20couple%20on%20cliff%20edge%2C%20ultra%20HD%20rich%20detail%2C%20dramatic%20clouds%2C%20warm%20romantic%20atmosphere%2C%20cinematic%20landscape%20photography&width=640&height=360&seq=video-thumb-010&orientation=landscape',
    duration: '39:45',
    views: 108000,
    date: '2026-07-30',
    description: '落日余晖中的绝美爱情岛视频，4K超清画质捕捉每一个温柔瞬间。橙红色的天空下，爱情故事如诗如画般展开。',
    tags: ['4K', '日落', '超清'],
    rating: 9.4,
  },
  {
    id: 'v011',
    slug: 'aiqingdao-huaxu-muhou-gushi',
    title: '爱情岛花絮之幕后故事',
    category: 'huaxu',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20film%20set%20with%20cameras%20and%20lighting%20equipment%2C%20crew%20members%20working%2C%20warm%20production%20lighting%2C%20casual%20and%20fun%20atmosphere%2C%20cinematic%20documentary%20style%20photography&width=640&height=360&seq=video-thumb-011&orientation=landscape',
    duration: '25:36',
    views: 65000,
    date: '2026-08-03',
    description: '独家揭秘爱情岛视频拍摄背后的趣事。从导演的创意构想到演员的真实反应，带你走进镜头之外的精彩世界。',
    tags: ['花絮', '幕后', '独家'],
    rating: 8.9,
  },
  {
    id: 'v012',
    slug: 'aiqingdao-huaxu-gaoxiao-ng',
    title: '爱情岛花絮之搞笑NG',
    category: 'huaxu',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20joyful%20group%20of%20people%20laughing%20together%20on%20a%20beautiful%20outdoor%20set%2C%20candid%20moment%2C%20natural%20sunlight%2C%20warm%20and%20happy%20atmosphere%2C%20cinematic%20candid%20photography&width=640&height=360&seq=video-thumb-012&orientation=landscape',
    duration: '18:22',
    views: 89000,
    date: '2026-07-29',
    description: '笑料不断的NG合集！爱情岛视频拍摄现场的欢乐时刻，看嘉宾们在镜头前各种可爱又搞笑的失误瞬间。',
    tags: ['花絮', '搞笑', 'NG'],
    rating: 9.0,
  },
  {
    id: 'v013',
    slug: 'aiqingdao-jijin-ganren-shunjian',
    title: '爱情岛集锦之感动瞬间',
    category: 'jijin',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20emotional%20and%20touching%20moment%20between%20two%20people%2C%20tears%20of%20joy%2C%20warm%20embrace%2C%20soft%20romantic%20lighting%2C%20intimate%20close-up%20shot%2C%20cinematic%20emotional%20photography&width=640&height=360&seq=video-thumb-013&orientation=landscape',
    duration: '32:48',
    views: 135000,
    date: '2026-08-01',
    description: '那些让人热泪盈眶的爱情岛视频集锦。从初次相遇到深情告白，每一个高能感人片段都值得我们反复品味。',
    tags: ['集锦', '感动', '高能'],
    rating: 9.5,
  },
  {
    id: 'v014',
    slug: 'aiqingdao-jijin-tianmi-duibai',
    title: '爱情岛集锦之甜蜜对白',
    category: 'jijin',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20close-up%20romantic%20scene%20of%20a%20couple%20whispering%20sweetly%20to%20each%20other%2C%20soft%20bokeh%20background%20of%20fairy%20lights%2C%20intimate%20warm%20atmosphere%2C%20cinematic%20portrait%20photography&width=640&height=360&seq=video-thumb-014&orientation=landscape',
    duration: '28:15',
    views: 120000,
    date: '2026-07-27',
    description: '最甜的爱情岛视频对白集锦！每一句情话都让人心动不已，每一个眼神都传递着深情。高甜预警，请备好糖果。',
    tags: ['集锦', '甜蜜', '对白'],
    rating: 9.3,
  },
  {
    id: 'v015',
    slug: 'aiqingdao-fangtan-jiabin-xinsheng',
    title: '爱情岛访谈之嘉宾心声',
    category: 'fangtan',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20intimate%20interview%20setting%20with%20comfortable%20armchairs%2C%20soft%20studio%20lighting%2C%20two%20people%20having%20a%20heartfelt%20conversation%2C%20plants%20in%20background%2C%20cinematic%20documentary%20style&width=640&height=360&seq=video-thumb-015&orientation=landscape',
    duration: '36:54',
    views: 72000,
    date: '2026-07-26',
    description: '走进爱情岛视频嘉宾的内心世界。听听他们在节目中的真实感受，以及节目之外那些不为人知的动人故事。',
    tags: ['访谈', '嘉宾', '心声'],
    rating: 9.1,
  },
  {
    id: 'v016',
    slug: 'aiqingdao-fangtan-zhizuoren',
    title: '爱情岛访谈之制作人特辑',
    category: 'fangtan',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20professional%20creative%20studio%20with%20storyboards%20on%20wall%2C%20warm%20ambient%20lighting%2C%20person%20sharing%20creative%20vision%2C%20cinematic%20documentary%20interview%20photography%2C%20artistic%20atmosphere&width=640&height=360&seq=video-thumb-016&orientation=landscape',
    duration: '42:10',
    views: 58000,
    date: '2026-07-22',
    description: '爱情岛视频制作团队独家访谈，揭秘节目创意来源与制作背后的故事。了解每一帧精美画面是如何诞生的。',
    tags: ['访谈', '制作', '幕后'],
    rating: 8.8,
  },
];

export const articles = [
  {
    id: 'a001',
    slug: 'aiqingdao-shipin-weishenme-zheme-huobao',
    title: '爱情岛视频为什么这么火爆？深度解析背后原因',
    category: 'zuixin',
    date: '2026-08-05',
    author: '爱情岛编辑',
    content: `<p>近年来，<strong>爱情岛视频</strong>在各大平台持续火爆，成为无数观众茶余饭后最热门的谈资。这档以真实情感为核心的视频内容，究竟凭什么能够俘获如此多观众的心？</p>
    <h2>一、真实感人的情感内核</h2>
    <p>爱情岛视频最大的魅力在于其<strong>真实性</strong>。与剧本化的综艺不同，爱情岛视频记录的是真实人物在特定情境下的自然反应和情感流露。观众能够从中看到自己的影子，产生强烈的共鸣。</p>
    <p>每一个眼神交汇、每一次羞涩微笑、每一段深情告白，都是不加修饰的真实情感。这种真实感让<strong>爱情岛视频在线观看</strong>的体验格外动人。</p>
    <h2>二、精美的画面制作</h2>
    <p>爱情岛视频在制作上精益求精。无论是海岛的碧海蓝天、山间的云雾缭绕，还是都市的霓虹闪烁，每一帧画面都经过精心设计。<strong>爱情岛视频高清</strong>画质更是让观众仿佛身临其境。</p>
    <h2>三、多元化的内容矩阵</h2>
    <p>从全集正片到精彩花絮，从嘉宾访谈到集锦合集，<strong>爱情岛视频全集</strong>构建了丰富的内容生态。不同喜好的观众都能找到自己感兴趣的内容类型，这也是<strong>爱情岛视频免费播放</strong>能够持续吸引观众的重要原因。</p>
    <h2>四、社交话题的引爆点</h2>
    <p>每一期爱情岛视频都会产生大量社交话题。观众在观看后自发讨论、分享，形成了强大的口碑传播效应。<strong>爱情岛视频最新资源</strong>总能迅速在社交媒体上引发热议。</p>`,
    tags: ['分析', '热门', '深度'],
    views: 56000,
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20trending%20video%20platform%20analytics%20dashboard%20concept%2C%20warm%20rose%20and%20gold%20color%20scheme%2C%20modern%20minimalist%20design%2C%20data%20visualization%2C%20soft%20gradient%20background%2C%20elegant%20and%20professional%20atmosphere&width=800&height=450&seq=article-thumb-001&orientation=landscape',
  },
  {
    id: 'a002',
    slug: 'aiqingdao-shipin-zuixin-yugao',
    title: '爱情岛视频最新预告：本周精彩看点抢先看',
    category: 'zuixin',
    date: '2026-08-04',
    author: '爱情岛编辑',
    content: `<p>最新一周的<strong>爱情岛视频</strong>即将上线，我们为你整理了本周最值得期待的精彩看点。</p>
    <h2>本周重磅：星空下的告白</h2>
    <p>本期<strong>爱情岛视频在线观看</strong>将迎来本季最感人的告白场景。在璀璨星空下，一位嘉宾准备了长达一个月的惊喜，这场告白被称为"爱情岛史上最浪漫的时刻"。</p>
    <h2>新嘉宾登场</h2>
    <p>本周还将迎来两位全新的嘉宾加入爱情岛大家庭。他们的到来会给现有的感情线带来怎样的变数？<strong>爱情岛视频最新资源</strong>将为你揭晓答案。</p>
    <h2>经典环节回归</h2>
    <p>观众呼声最高的"真心话大冒险"环节将在本周回归。<strong>爱情岛视频高清</strong>镜头将捕捉每一个精彩反应，不容错过。</p>`,
    tags: ['预告', '看点', '最新'],
    views: 42000,
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cinematic%20coming%20soon%20teaser%20concept%20with%20star%20elements%2C%20warm%20dramatic%20lighting%2C%20golden%20and%20rose%20accents%2C%20movie%20premiere%20vibe%2C%20elegant%20typography%20background%2C%20soft%20glow%20effects&width=800&height=450&seq=article-thumb-002&orientation=landscape',
  },
  {
    id: 'a003',
    slug: 'aiqingdao-shipin-gaoqing-zhinan',
    title: '爱情岛视频高清观看指南：如何获得最佳画质体验',
    category: 'gaoqing',
    date: '2026-08-02',
    author: '爱情岛编辑',
    content: `<p>想要获得<strong>爱情岛视频高清</strong>的最佳观看体验？本文为你提供全方位的指南。</p>
    <h2>画质选择建议</h2>
    <p>爱情岛视频提供多种画质选项。对于追求极致画质的观众，建议选择4K超清模式观看<strong>爱情岛视频高清</strong>内容。普通网络环境可选择1080P高清，同样能获得出色的视觉体验。</p>
    <h2>设备推荐</h2>
    <p>在大屏幕设备上观看<strong>爱情岛视频全集</strong>效果最佳。推荐使用支持HDR显示的设备，能够更好地呈现爱情岛视频中精美的光影效果。</p>
    <h2>网络优化</h2>
    <p>为了流畅观看<strong>爱情岛视频免费播放</strong>，建议使用稳定的Wi-Fi网络。平台支持多线路自动切换，确保播放不卡顿。</p>`,
    tags: ['指南', '高清', '体验'],
    views: 38000,
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20home%20theater%20setup%20with%20large%204K%20screen%20displaying%20cinematic%20nature%20scene%2C%20cozy%20living%20room%2C%20warm%20ambient%20lighting%2C%20premium%20entertainment%20experience%2C%20elegant%20interior&width=800&height=450&seq=article-thumb-003&orientation=landscape',
  },
];

export const faqItems = [
  {
    question: '爱情岛视频需要付费观看吗？',
    answer: '爱情岛视频提供免费在线观看服务，所有视频内容均可免费播放，无需任何费用。您可以直接访问我们的网站，选择喜欢的视频开始观看。',
  },
  {
    question: '爱情岛视频支持哪些设备观看？',
    answer: '爱情岛视频全面支持PC端、平板电脑和手机等多种设备。无论在电脑前还是移动设备上，都能流畅观看高清视频内容。',
  },
  {
    question: '爱情岛视频的更新频率是怎样的？',
    answer: '爱情岛视频保持高频更新，每周至少更新3-5期新内容，包括正片全集、精彩花絮、集锦合集等多种类型。关注我们，不错过任何精彩更新。',
  },
  {
    question: '如何搜索想看的爱情岛视频内容？',
    answer: '您可以通过首页的搜索功能，输入关键词查找相关视频。也可以通过分类导航浏览不同类别的爱情岛视频内容，如全集、最新更新、精选推荐等。',
  },
  {
    question: '爱情岛视频可以下载离线观看吗？',
    answer: '爱情岛视频目前支持在线高清播放，无需下载即可流畅观看。在线播放免去了下载等待时间和存储空间占用，让您随时随地畅享精彩内容。',
  },
  {
    question: '观看爱情岛视频时卡顿怎么办？',
    answer: '如果您在观看时遇到卡顿，可以尝试以下方法：切换播放线路（平台支持多线路切换）、降低画质到1080P、检查网络连接状态。我们的系统会自动为您选择最优线路。',
  },
  {
    question: '爱情岛视频有App可以下载吗？',
    answer: '目前爱情岛视频以网站形式提供服务，您可以通过浏览器直接访问。网站采用响应式设计，在手机上的体验同样出色，无需额外下载App。',
  },
  {
    question: '如何获取爱情岛视频的最新资讯？',
    answer: '关注我们的网站首页，所有最新爱情岛视频更新和资讯都会第一时间在首页展示。您也可以将网站加入浏览器收藏夹，方便随时访问。',
  },
];